import rewardSVG from 'assets/icons/rewards.svg'
import close from 'assets/icons/close-white.svg'
import { useAppSelector } from 'state/hooks'
import { hideRewardBanner, selectShowRewardBanner } from 'state/slices/ui/dash'

export function RewardBanner() {
  const show = useAppSelector(selectShowRewardBanner)
  if (!show) return null
  return (
    <div className="reward-banner">
      <div className="reward-banner__left">
        <img src={rewardSVG} alt="reward" />
        <div className="reward-banner__content">
          <h3>We distribute yield incentives weekly!</h3>
          <p>Earn boosted yield by maintaining open positions in incentivized pools</p>
        </div>
      </div>
      <img src={close} alt="close" className="clickable" onClick={hideRewardBanner} />
    </div>
  )
}
